import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { Salaries } from '../../../types/personShow';

type Props = {
  onChangedBody: (name: string, value: any) => void;
  salary: number;
  target: string;
  salaries: Salaries[];
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  salary,
  target,
  salaries,
}) => {
  const [selectedSalary, setSelectedSalary] = useState<number>(salary);

  useEffect(() => {
    setSelectedSalary(salary);
  }, [salary]);

  const handleChange = (id: number) => {
    setSelectedSalary(id);
    onChangedBody('salary', id);
  };

  return (
    <Presentation
      selectedSalary={selectedSalary}
      salaries={salaries}
      onSelect={handleChange}
     />
  );
};
